@if (isNewAccount() && showOnboarding() && onboardingTasks$ | async; as onboardingTasks) {
  <div class="tw-mb-6">
    <app-onboarding [title]="'getStartedWithYourVault' | i18n" (dismiss)="hideOnboarding()">
      <app-onboarding-task
        [title]="'onboardingCreateYourAccountTitle' | i18n"
        [completed]="onboardingTasks.createAccount"
        [isDisabled]="true"
      ></app-onboarding-task>

      <app-onboarding-task
        [title]="'onboardingImportYourPasswordsTitle' | i18n"
        [completed]="onboardingTasks.importData"
        [route]="['/tools/import']"
      >
        {{ "onboardingImportDataSubtitlePrefix" | i18n }}
        <a bitLink linkType="primary" routerLink="/vault">{{
          "onboardingImportNewItemLink" | i18n
        }}</a>
        {{ "onboardingImportDataSubtitleSuffix" | i18n }}
      </app-onboarding-task>

      <app-onboarding-task
        [title]="'onboardingInstallTheBrowserExtensionTitle' | i18n"
        [subtitle]="'onboardingInstallExtensionSubtitle' | i18n"
        [showSubtitleWhenComplete]="true"
        [completed]="onboardingTasks.installExtension"
        (ctaClick)="navigateToExtension()"
      ></app-onboarding-task>
    </app-onboarding>
  </div>
}
